var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1.35252 8L10.6474 8C11.774 8 12.405 6.7944 11.709 5.9718L7.0616 0.479201C6.521 -0.159799 5.47898 -0.159799 4.93846 0.479201L0.290978 5.9718C-0.404982 6.7944 0.226038 8 1.35252 8Z",
    fill: "#2F2F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownMenu);
export default __webpack_public_path__ + "static/media/downMenu.2ae96e0015c22e1353bb031baab43987.svg";
export { ForwardRef as ReactComponent };